import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.qadataset.verify');
    // ...existing code...
import { Input, OnInit, ViewChild, ElementRef, HostListener, AfterViewInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { marked } from 'marked';

declare const wiz: any;

interface TypeConfig {
    value: string;
    label: string;
}

interface AdminUser {
    user_id: string;
    name: string;
}

@Component({
    selector: 'wiz-portal-qadataset-verify',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.qadataset.verify/view.scss */
.mr-30 {
  margin-left: 30%;
}

.type-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 10px;
  font-weight: 500;
  border: 1px solid;
}

.type-tag.summary {
  background-color: #dbeafe;
  color: #1e40af;
  border-color: #93c5fd;
}

.type-tag.concept {
  background-color: #f3e8ff;
  color: #6b21a8;
  border-color: #d8b4fe;
}

.type-tag.reasoning {
  background-color: #d1fae5;
  color: #065f46;
  border-color: #6ee7b7;
}

.type-tag.decision {
  background-color: #fed7aa;
  color: #9a3412;
  border-color: #fdba74;
}

.type-tag.treatment_principle {
  background-color: #fce7f3;
  color: #9f1239;
  border-color: #f9a8d4;
}

.type-tag.prescription {
  background-color: #cffafe;
  color: #155e75;
  border-color: #67e8f9;
}

.type-tag.procedure {
  background-color: #fef3c7;
  color: #92400e;
  border-color: #fcd34d;
}

.type-tag.evidence {
  background-color: #e0e7ff;
  color: #3730a3;
  border-color: #a5b4fc;
}

.type-tag.compare {
  background-color: #fee2e2;
  color: #991b1b;
  border-color: #fca5a5;
}

.type-tag.safety {
  background-color: #fef3c7;
  color: #78350f;
  border-color: #fcd34d;
}`],
})
export class PortalQadatasetVerifyComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() id: string;

    // 검수자별 엑셀 다운로드 토글
    public showReviewerDropdown: boolean = false;
    public selectedReviewer: string = "";

    // 디버깅: 드롭다운 토글 함수 (view.pug에서 (click)="toggleReviewerDropdown()"으로 연결)
    public toggleReviewerDropdown() {
        this.showReviewerDropdown = true;
        console.log('[DEBUG] showReviewerDropdown:', this.showReviewerDropdown);
        console.log('[DEBUG] assignedReviewers:', this.assignedReviewers);
        console.log('[DEBUG] selectedReviewer:', this.selectedReviewer);
    }

    constructor(@Inject( Service)         public service: Service,@Inject( Router)         private router: Router,@Inject( DomSanitizer    )         private sanitizer: DomSanitizer    ) { }

    public group: any = null;
    public questions: any[] = [];

    public loading: boolean = false;
    public error: string = '';
    // ===== 생성 진행 상태 =====
    public generating: boolean = false;
    public progressCurrent: number = 0;
    public progressTotal: number = 0;

    // 새롭게 추가 
    viewMode: 'card' | 'list' = 'card';
    expandedQuestions: Set<number> = new Set();
    public showScrollTopButton: boolean = false;
    private scrollContainer: HTMLElement | null = null;
    private scrollInitAttempts: number = 0;
    private readonly scrollListener = () => {
        const offset = this.scrollContainer ? this.scrollContainer.scrollTop : this.getWindowScrollOffset();
        this.updateScrollButton(offset);
    };

    // Admin
    public modalOpen: boolean = false;
    public selectedModel: string = "gpt-5.2";
    public systemPrompt: string = "";
    public typePrompts: { [key: string]: string } = {};

    // ===== 프롬프트 템플릿 관련 변수 추가 =====
    public otherAdmins: AdminUser[] = [];

    // 필드명 매핑 (화면 필드 -> DB 컬럼명)
    private readonly FIELD_MAPPING: { [key: string]: string } = {
        common: 'common_prompt',
        system: 'system_prompt',
        summary: 'main_summary_prompt',
        concept: 'main_concept_prompt',
        reasoning: 'main_reasoning_prompt',
        decision: 'main_decision_prompt',
        treatment_principle: 'main_treatment_principle_prompt',
        prescription: 'main_prescription_prompt',
        procedure: 'main_procedure_prompt',
        evidence: 'aux_evidence_prompt',
        compare: 'aux_compare_prompt',
        safety: 'aux_safety_prompt'
    };

    // 기본 프롬프트 정의
    private readonly DEFAULT_PROMPTS = {
        commonPrompt: '한의학 전문 지식을 바탕으로 정확하고 체계적인 질문과 답변을 생성해주세요.',
        systemPrompt: `당신은 한의학 전문 Q&A 데이터셋 생성기입니다.
주어진 출처 텍스트를 기반으로 파인튜닝용 고품질 질문-답변 쌍을 생성합니다.

## 핵심 원칙
- 출처 텍스트에 명시된 정보만 사용합니다.
- 질문은 명확하고, 답변은 정확해야 합니다.
- 한의학 용어의 정확성을 유지합니다.

## 질문 유형 (다양하게 생성)
1. **정의형**: "~은(는) 무엇인가?"
2. **구성형**: "~의 구성 요소는?"
3. **분류형**: "~은(는) 어떻게 분류되는가?"
4. **특징형**: "~의 특징/증상/적응증은?"
5. **비교형**: "~와 ~의 차이점은?" (출처에 비교 내용이 있는 경우만)
6. **관계형**: "~은(는) ~와 어떤 관계가 있는가?"

## 답변 작성 가이드
- 출처 텍스트의 내용을 정확히 반영합니다.
- 전문 용어는 그대로 사용하되, 필요시 간단히 부연합니다.
- 나열이 필요한 경우 번호나 쉼표로 구분합니다.
- 답변 길이는 내용에 맞게 자연스럽게 작성합니다 (1~5문장).

## 한자 표기
- 한자가 나오면 바로 뒤에 한글 독음을 괄호로 병기합니다.
- 예: 氣血(기혈), 腎陽虛(신양허), 四君子湯(사군자탕)

## 품질 기준
- 질문만 보고도 무엇을 묻는지 명확히 알 수 있어야 합니다.
- 답변은 질문에 대한 직접적인 응답이어야 합니다.
- 출처에 없는 추론, 임상 권고, 효능 평가는 포함하지 않습니다.

## 출력 형식
JSON 객체만 출력합니다:
{"question": "질문 내용", "answer": "답변 내용"}`,
        typePrompts: {
            summary: '출처 내용을 짧게 요약하고 핵심만 정리하는 질문을 생성하세요. 대표 신호: "요약, 정리, 핵심, 개요". 예시: "편두통의 특징을 요약하라."',
            concept: '한의학 개념(장부, 경락, 기혈진액 등)을 설명하는 질문을 생성하세요. 대표 신호: "정의, 의미, 기능, 분류, 개념". 예시: "삼초의 개념과 기능을 설명하라."',
            reasoning: '"왜/어떻게"를 원인→과정→결과로 설명하는 질문을 생성하세요. 대표 신호: "왜, 어떻게, 기전, 병리 변화, 경로". 예시: "진액 배설 장애가 유발하는 병리 변화를 설명하라."',
            decision: '정보/기준을 적용해 진단·변증·감별·선정을 판단하는 질문을 생성하세요. 대표 신호: "어떤 경우, 감별, 진단, 변증, 기준에 따라". 예시: "해당 소견에서 감별해야 할 변증 포인트를 제시하라."',
            treatment_principle: '질환/병인에 대해 치료 방향(치법)을 정리하는 질문을 생성하세요. 대표 신호: "치료 원칙, 치법, 치료 전략, 치료 방향". 예시: "편두통의 병인별 치료 원칙을 정리하라." 주의: 처방 구성/가감까지 들어가면 처방운용으로 분류.',
            prescription: '처방을 어떻게 구성하고 가감하는지(운용 규칙)를 다루는 질문을 생성하세요. 대표 신호: "가감법, 약재 추가/삭제, 용량, 복용, 배합". 예시: "독활기생탕의 가감법을 조건별로 정리하라."',
            procedure: '실제 시행 단계/조건/횟수/부위 같은 프로토콜을 다루는 질문을 생성하세요. 대표 신호: "어떻게 시행, 절차, 단계, 횟수, 자극 조건". 예시: "전침 치료를 어떤 조건으로 어떻게 시행하는가?"',
            evidence: '출처 문장/페이지/표/연구 근거를 제시하도록 요구하는 질문을 생성하세요. 예시: "근거 문장 1–2개를 인용하여 설명하라."',
            compare: '2개 이상 대상이 있고 공통 기준으로 비교를 요구하는 질문을 생성하세요. 예시: "매선 vs 전침을 (절차/주의/장단점) 기준으로 비교하라."',
            safety: '금기·부작용·위험·주의가 요구되는 질문을 생성하세요. 예시: "시술 시 주의점과 금기를 함께 정리하라."'
        }
    };

    public TYPE_HINT = this.DEFAULT_PROMPTS.typePrompts;

    public getTypePrompt(type: string): string {
        return this.typePrompts[type] || this.TYPE_HINT[type] || "";
    }

    public setTypePrompt(type: string, prompt: string) {
        this.typePrompts[type] = prompt;
    }

    public isContextMode: boolean = false;
    public contextText: string = "";

    public genType: string = "summary";  // 기본값 설정
    public genTypes: string[] = [];
    public selectedTypesHints: string[] = [];

    public get mainGenTypes(): string[] {
        return (this.genTypes || []).filter((type) => this.isMainType(type));
    }

    public get auxGenTypes(): string[] {
        return (this.genTypes || []).filter((type) => this.isAuxiliaryType(type));
    }

    // 주 라벨 (필수, 최소 1개 선택)
    public mainTypes: TypeConfig[] = [
        { value: 'summary', label: '요약' },
        { value: 'concept', label: '개념설명' },
        { value: 'reasoning', label: '인과/기전' },
        { value: 'decision', label: '진단/변증' },
        { value: 'treatment_principle', label: '치료원칙' },
        { value: 'prescription', label: '처방운용' },
        { value: 'procedure', label: '시술절차' }
    ];

    // 보조 라벨 (선택, 0~2개)
    public auxiliaryTypes: TypeConfig[] = [
        { value: 'evidence', label: '근거제시' },
        { value: 'compare', label: '비교분석' },
        { value: 'safety', label: '안전/주의' }
    ];

    // 프롬프트 모달 관련 변수
    public promptModalOpen: boolean = false;
    public selectedPromptType: string = '';
    public selectedPromptCategory: 'main' | 'aux' = 'main';

    // 프롬프트 모달 열기
    public showPromptModal(type: string, category: 'main' | 'aux') {
        this.selectedPromptType = type;
        this.selectedPromptCategory = category;
        this.promptModalOpen = true;
        this.service.render();
    }

    // 프롬프트 모달 닫기
    public closePromptModal() {
        this.promptModalOpen = false;
        this.selectedPromptType = '';
        this.service.render();
    }
    public allTypes = [...this.mainTypes, ...this.auxiliaryTypes];

    public genCount: number = 10;
    // 프롬프트 
    public genPrompt: string = "";

    public onSelectType() {
        this.genPrompt = this.TYPE_HINT[this.genType] || "";

        setTimeout(() => {
            this.genPrompt = this.TYPE_HINT[this.genType] || "";
            this.service.render();
        }, 0);
    }
    public topKModal = { open: false };
    public topKDocs: any[] = [];
    public latestTopK: any[] = [];

    //엑셀 
    public uploadingExcel: boolean = false;
    public uploadProgress: string = "";

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow();

        await this.loadAll();
        await this.loadGroup();
        
        // ===== 프롬프트 템플릿 로드 추가 =====
        await this.loadMyPrompt();
        await this.loadOtherAdmins();
        
        await this.service.render();
    }

    public ngAfterViewInit() {
        this.initScrollContainer();
    }

    public ngOnDestroy() {
        if (this.scrollContainer) {
            this.scrollContainer.removeEventListener('scroll', this.scrollListener);
        }
    }

    private initScrollContainer() {
        this.scrollContainer = document.querySelector('[data-portal-scroll="true"]') as HTMLElement | null;
        if (!this.scrollContainer) {
            this.scrollContainer = document.scrollingElement as HTMLElement | null;
        }

        if (this.scrollContainer) {
            this.scrollContainer.addEventListener('scroll', this.scrollListener, { passive: true });
            this.scrollListener();
            return;
        }

        if (this.scrollInitAttempts < 5) {
            this.scrollInitAttempts += 1;
            setTimeout(() => this.initScrollContainer(), 300);
        }
    }

    public excelMenuOpen: boolean = false;

    // ===== 프롬프트 템플릿 관련 메서드 추가 =====
    
    // 내가 저장한 프롬프트 불러오기
    public async loadMyPrompt(): Promise<void> {
        try {
            const res = await wiz.call("get_my_prompts");

            if (res && res.code === 200 && res.data) {
                this.applyFullPrompt(res.data);
            } else {
                // 저장된 프롬프트가 없으면 기본값 사용
                this.genPrompt = this.DEFAULT_PROMPTS.commonPrompt;
                this.systemPrompt = this.DEFAULT_PROMPTS.systemPrompt;
            }
        } catch (error) {
            console.error('내 프롬프트 불러오기 실패:', error);
            // 에러 시에도 기본값 사용
            this.genPrompt = this.DEFAULT_PROMPTS.commonPrompt;
            this.systemPrompt = this.DEFAULT_PROMPTS.systemPrompt;
        }
    }

    // 다른 관리자 목록 불러오기
    public async loadOtherAdmins(): Promise<void> {
        try {
            const res = await wiz.call("get_prompt_admins");
            
            if (res && res.code === 200) {
                this.otherAdmins = res.data?.admins || [];
            }
        } catch (error) {
            console.error('관리자 목록 불러오기 실패:', error);
        }
    }

    // 특정 필드만 다른 관리자 프롬프트로 불러오기
    public async loadAdminPromptField(fieldType: string, event: any): Promise<void> {
        const userId = event.target.value;
        
        if (!userId) return;

        try {
            const res = await wiz.call("get_user_prompts", { user_id: userId });

            if (res && res.code === 200 && res.data) {
                // DB 컬럼명 가져오기
                const dbFieldName = this.FIELD_MAPPING[fieldType];
                const value = res.data[dbFieldName];

                // 해당 필드만 업데이트
                if (fieldType === 'common') {
                    this.genPrompt = value || '';
                } else if (fieldType === 'system') {
                    this.systemPrompt = value || '';
                } else {
                    // 타입별 프롬프트
                    this.typePrompts[fieldType] = value || '';
                }

                // 드롭다운 초기화
                event.target.value = '';
                await this.service.render();
            }
        } catch (error) {
            console.error('프롬프트 필드 불러오기 실패:', error);
            alert('프롬프트를 불러오는데 실패했습니다.');
        }
    }

    // 전체 프롬프트 적용
    private applyFullPrompt(data: any): void {
        this.genPrompt = data.common_prompt || this.DEFAULT_PROMPTS.commonPrompt;
        this.systemPrompt = data.system_prompt || this.DEFAULT_PROMPTS.systemPrompt;

        // 타입별 프롬프트
        this.typePrompts = {
            summary: data.main_summary_prompt || this.DEFAULT_PROMPTS.typePrompts.summary,
            concept: data.main_concept_prompt || this.DEFAULT_PROMPTS.typePrompts.concept,
            reasoning: data.main_reasoning_prompt || this.DEFAULT_PROMPTS.typePrompts.reasoning,
            decision: data.main_decision_prompt || this.DEFAULT_PROMPTS.typePrompts.decision,
            treatment_principle: data.main_treatment_principle_prompt || this.DEFAULT_PROMPTS.typePrompts.treatment_principle,
            prescription: data.main_prescription_prompt || this.DEFAULT_PROMPTS.typePrompts.prescription,
            procedure: data.main_procedure_prompt || this.DEFAULT_PROMPTS.typePrompts.procedure,
            evidence: data.aux_evidence_prompt || this.DEFAULT_PROMPTS.typePrompts.evidence,
            compare: data.aux_compare_prompt || this.DEFAULT_PROMPTS.typePrompts.compare,
            safety: data.aux_safety_prompt || this.DEFAULT_PROMPTS.typePrompts.safety
        };
    }

    // 특정 필드만 원본으로 초기화
    public resetField(fieldType: string): void {
        if (fieldType === 'common') {
            this.genPrompt = this.DEFAULT_PROMPTS.commonPrompt;
        } else if (fieldType === 'system') {
            this.systemPrompt = this.DEFAULT_PROMPTS.systemPrompt;
        } else {
            this.typePrompts[fieldType] = this.DEFAULT_PROMPTS.typePrompts[fieldType] || '';
        }
        this.service.render();
    }

    // 전체 원본으로 초기화
    public async resetAllToDefault(): Promise<void> {
        if (confirm('모든 프롬프트를 원본으로 초기화하시겠습니까?')) {
            this.genPrompt = this.DEFAULT_PROMPTS.commonPrompt;
            this.systemPrompt = this.DEFAULT_PROMPTS.systemPrompt;
            
            // 새로운 객체로 완전히 교체
            this.typePrompts = {
                summary: this.DEFAULT_PROMPTS.typePrompts.summary,
                concept: this.DEFAULT_PROMPTS.typePrompts.concept,
                reasoning: this.DEFAULT_PROMPTS.typePrompts.reasoning,
                decision: this.DEFAULT_PROMPTS.typePrompts.decision,
                treatment_principle: this.DEFAULT_PROMPTS.typePrompts.treatment_principle,
                prescription: this.DEFAULT_PROMPTS.typePrompts.prescription,
                procedure: this.DEFAULT_PROMPTS.typePrompts.procedure,
                evidence: this.DEFAULT_PROMPTS.typePrompts.evidence,
                compare: this.DEFAULT_PROMPTS.typePrompts.compare,
                safety: this.DEFAULT_PROMPTS.typePrompts.safety
            };
            
            await this.service.render();
        }
    }

    // 내 프롬프트로 저장
    public async saveMyPrompt(): Promise<void> {
        const saveData = {
            common_prompt: this.genPrompt,
            system_prompt: this.systemPrompt,
            main_summary_prompt: this.typePrompts['summary'] || null,
            main_concept_prompt: this.typePrompts['concept'] || null,
            main_reasoning_prompt: this.typePrompts['reasoning'] || null,
            main_decision_prompt: this.typePrompts['decision'] || null,
            main_treatment_principle_prompt: this.typePrompts['treatment_principle'] || null,
            main_prescription_prompt: this.typePrompts['prescription'] || null,
            main_procedure_prompt: this.typePrompts['procedure'] || null,
            aux_evidence_prompt: this.typePrompts['evidence'] || null,
            aux_compare_prompt: this.typePrompts['compare'] || null,
            aux_safety_prompt: this.typePrompts['safety'] || null
        };

        try {
            const res = await wiz.call("save_my_prompts", saveData);
            
            if (res && res.code === 200) {
                alert('내 프롬프트로 저장되었습니다.');
            } else {
                alert(res?.error || '저장에 실패했습니다.');
            }
        } catch (error) {
            console.error('프롬프트 저장 실패:', error);
            alert('저장에 실패했습니다.');
        }
    }

    // 주 라벨 여부 확인
    public isMainType(type: string): boolean {
        return this.mainTypes.some(t => t.value === type);
    }

    // 보조 라벨 여부 확인
    public isAuxiliaryType(type: string): boolean {
        return this.auxiliaryTypes.some(t => t.value === type);
    }

    // ===== 기존 메서드들 =====

    public async openTopKModal(q: any) {
        console.log("latestTopK 확인:", this.latestTopK);
        if (this.latestTopK && this.latestTopK.length > 0) {
            this.topKDocs = this.latestTopK;
            this.topKModal.open = true;
            this.service.render();
            return;
        }

        alert("Top-K 정보가 없습니다.");
        await this.service.render();
    }

    public async closeTopKModal() {
        this.topKModal.open = false;
        await this.service.render();
    }

    public pdfUrl: SafeResourceUrl | null = null;
    public showPdf: boolean = false;
    public pdfSrc: any = null;

    public pdfModal = {
        open: false,
        url: null,
        page: 1
    };

    currentQuestion: any = null;
    pdfSrcWithToolbar: any = null;

    public showPdfSource: boolean = false;
    public pdfSourceSrc: any = null;
    public pdfSourceSrcWithToolbar: any = null;
    public currentPdfQuestion: any = null;
    public pdfTopKDocs: any[] = [];

    public async showSourceModal(q: any) {
        if (!q) return;
        this.isContextMode = false;

        this.currentQuestion = q;

        console.log("출처 DEBUG q =", q);

        try {
            const res = await wiz.call("get_topk_for_qa", {
                qa_id: q.id
            });

            if (res && res.code === 200) {
                this.topKDocs = res.data.top_k || [];
            } else {
                this.topKDocs = [];
            }
            console.log("QA별 DB Top-K 로드됨:", this.topKDocs);

            let doc = this.topKDocs[0];
            if (doc.context) {
                this.isContextMode = true;
                this.contextText = doc.context;
                this.showPdf = true;
            }
        } catch (e) {
            console.error("get_topk_for_qa 호출 오류:", e);
            this.topKDocs = [];
        }

        this.highlightText = q?.text || q?.answer || "";

        let sourceFile = q?.source_file;
        let sourcePage = q?.source_page;
        const storageId = this.group?.vectordb_id;

        if ((!sourceFile || sourcePage == null) && this.topKDocs.length > 0) {
            const top1 = this.topKDocs[0];
            sourceFile = top1.file;
            sourcePage = top1.page;
        }

        if (!sourceFile || !storageId) {
            alert("출처 파일 경로가 없습니다.");
            return;
        }

        const cacheBuster = Date.now();

        const pdfUrl =
            wiz.url('get_pdf_file') +
            `?storage=${encodeURIComponent(storageId)}` +
            `&path=${encodeURIComponent(sourceFile)}` +
            `&t=${cacheBuster}#page=${sourcePage}&navpanes=0`;

        console.log("PDF URL =", pdfUrl);

        this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(pdfUrl);
        this.pdfSrcWithToolbar = this.pdfSrc;

        this.showPdf = true;

        await this.service.render();
    }

    public async showPdfModal(q: any) {
        if (!q) return;

        this.currentPdfQuestion = q;

        console.log("PDF 출처 DEBUG q =", q);

        try {
            const res = await wiz.call("get_topk_for_qa", {
                qa_id: q.id
            });

            if (res && res.code === 200) {
                this.pdfTopKDocs = res.data.top_k || [];
            } else {
                this.pdfTopKDocs = [];
            }
            console.log("PDF Top-K 로드됨:", this.pdfTopKDocs);
        } catch (e) {
            console.error("get_topk_for_qa 호출 오류:", e);
            this.pdfTopKDocs = [];
        }

        let sourceFile = q?.source_file;
        let sourcePage = q?.source_page;
        const storageId = this.group?.vectordb_id;

        if ((!sourceFile || sourcePage == null) && this.pdfTopKDocs.length > 0) {
            const top1 = this.pdfTopKDocs[0];
            sourceFile = top1.file;
            sourcePage = top1.page;
        }

        if (!sourceFile || !storageId) {
            alert("출처 파일 경로가 없습니다.");
            return;
        }

        const cacheBuster = Date.now();

        const pdfUrl =
            wiz.url('get_pdf_file') +
            `?storage=${encodeURIComponent(storageId)}` +
            `&path=${encodeURIComponent(sourceFile)}` +
            `&t=${cacheBuster}#page=${sourcePage}&navpanes=0`;

        console.log("PDF 출처 URL =", pdfUrl);

        this.pdfSourceSrc = this.sanitizer.bypassSecurityTrustResourceUrl(pdfUrl);
        this.pdfSourceSrcWithToolbar = this.pdfSourceSrc;

        this.showPdfSource = true;

        await this.service.render();
    }

    public onSelectTopK(event: any) {
        const index = Number(event.target.value);
        const doc = this.topKDocs[index];
        if (!doc) return;

        const cacheBuster = Date.now();
        if (this.isContextMode == true) {
            this.contextText = doc.context;
        }
        else {
            const pdfUrl =
                wiz.url("get_pdf_file") +
                `?storage=${encodeURIComponent(this.group?.vectordb_id)}` +
                `&path=${encodeURIComponent(doc.file)}` +
                `&t=${cacheBuster}` +
                `#page=${doc.page}`;

            console.log("선택된 Top-K PDF URL =", pdfUrl);

            this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(pdfUrl);
        }

        this.service.render();
    }

    public async closePdfSourceModal() {
        this.showPdfSource = false;
        this.pdfSourceSrc = null;
        this.pdfSourceSrcWithToolbar = null;
        this.currentPdfQuestion = null;
        this.pdfTopKDocs = [];
        await this.service.render();
    }

    highlightText = "";

    onPdfLoaded(event: any) {
        setTimeout(() => {
            this.searchAndHighlight(this.highlightText);
        }, 300);
    }

    searchAndHighlight(text: string) {
        const viewer: any = (window as any).PDFViewerApplication;
        if (!viewer) return;

        viewer.findController.executeCommand("find", {
            query: text,
            phraseSearch: true,
            highlightAll: true,
            caseSensitive: false
        });
    }

    // 검수자 목록 (id, name, email)
    public assignedReviewers: { id: string, name: string, email: string }[] = [];
    public selectedReviewer: string = "";

    public async loadGroup() {
        console.log('[DEBUG] loadGroup() 호출');
        this.loading = true;

        const res = await wiz.call("get_group_detail", { id: this.id });

        if (res?.code === 200) {
            this.group = res.data;
            console.log("GROUP DATA =", this.group);

            console.log("검수 대기:", this.group.my_pending_count);
            console.log("검수 완료:", this.group.my_review_count);

            const storageKey = `latestTopK_${this.group.id}`;
            const saved = localStorage.getItem(storageKey);

            if (saved) {
                try {
                    this.latestTopK = JSON.parse(saved);
                    console.log("로컬스토리지에서 latestTopK 불러옴 =", this.latestTopK);
                } catch (e) {
                    console.warn("localStorage latestTopK 파싱 실패:", e);
                }
            } else {
                console.log("localStorage에 latestTopK 없음");
            }

            const assignedRes = await wiz.call("get_assigned_users", {
                group_id: this.id
            });

            const users = assignedRes?.data?.users || [];
            this.assignedReviewers = users.map(u => ({ id: u.id, name: u.name, email: u.email }));
            console.log('[DEBUG] assignedReviewers after load:', this.assignedReviewers);

            // 검수자 수가 2명 이상이 아니면 드롭다운 강제 닫기
            if (this.assignedReviewers.length <= 1) {
                this.showReviewerDropdown = false;
                this.selectedReviewer = "";
            } else {
                console.log('[DEBUG] assignedReviewers.length > 1, 드롭다운 조건 충족');
            }
        }

        this.loading = false;
        await this.service.render();
    }

    public async loadAll() {
        this.loading = true;
        this.error = '';
        await this.service.render();

        try {
            await this.loadGroupInfo();
            await this.loadQuestions();
        } catch {
            this.error = "데이터를 불러오는 중 오류가 발생했습니다.";
        }

        this.loading = false;
        await this.service.render();
    }

    private async loadGroupInfo() {
        const res = await wiz.call("get_group_detail", { id: this.id });

        if (!res || res.code !== 200) {
            this.error = res?.error || "그룹 정보를 가져오지 못했습니다.";
            return;
        }

        this.group = res.data;
    }

    private async loadQuestions() {
        const res = await wiz.call("get_group_questions", {
            id: this.id,
            include_reviewed: true
        });

        if (!res || res.code !== 200) {
            console.log(res.code)
            this.error = res?.error || "Q&A 리스트를 가져오지 못했습니다.";
            this.questions = [];
            return;
        }

        this.questions = res.data.map((q: any) => {
            const rv = q.review;

            let status: 'approved' | 'pending' | 'rejected' | null = null;

            if (rv && rv.accept !== null && rv.accept !== undefined) {
                if (rv.accept === 1) status = 'approved';
                else if (rv.accept === -1) status = 'rejected';
                else if (rv.accept === 0) status = 'pending';
            }

            return {
                ...q,
                status,
                comment: rv?.comment ?? null,
                source_file: q.source_file ?? null,
                source_page: q.source_page ?? null,
            };
        });

        this.questions.sort((a, b) => {
            if (a.status === null && b.status !== null) return -1;
            if (a.status !== null && b.status === null) return 1;

            return 0;
        });
    }

    public async deleteQuestion(q: any) {
        if (!q || !q.id) return;

        const ok = confirm(
            "해당 Q&A를 삭제하시겠습니까?\n\n" +
            "이 질문과 연결된 검수 기록(qa_review)도 함께 삭제됩니다."
        );
        if (!ok) return;

        try {
            const res = await wiz.call("delete_question", { id: q.id });

            if (!res || res.code !== 200) {
                alert(res?.error || res?.data?.error || "Q&A 삭제 실패");
                return;
            }

            this.questions = this.questions.filter(item => item.id !== q.id);

            await this.loadGroupInfo();
        } catch (e) {
            console.error("[qadataset-verify] deleteQuestion error:", e);
            alert("Q&A 삭제 중 오류가 발생했습니다.");
        }

        await this.service.render();
    }

    public async setQuestionStatus(q: any, status: 'pending' | 'approved' | 'rejected') {
        if (!q || !q.id) return;

        const prevStatus = q.status;
        const prevComment = q.comment;

        q.status = status;
        await this.service.render();

        try {
            const res = await wiz.call("update_question_status", {
                id: q.id,
                status,
                comment: q.comment || ""
            });

            if (!res || res.code !== 200) {
                q.status = prevStatus;
                q.comment = prevComment;
                alert(res?.error || "상태 변경 실패");
                await this.service.render();
                return;
            }

            await this.loadGroupInfo();
            await this.loadQuestions();

        } catch (e) {
            q.status = prevStatus;
            q.comment = prevComment;
            alert("상태 변경 중 오류");
        }

        await this.service.render();
    }

    public async openGenerateModal() {
        if (this.group?.status_closed === "Y") {
            alert("마감된 그룹에서는 Q&A를 생성할 수 없습니다.");
            return;
        }

        // ===== 모달 열 때 프롬프트 초기화하지 않도록 변경 =====
        // 이미 loadMyPrompt에서 불러왔으므로 그대로 유지
        
        this.modalOpen = true;
        this.genTypes = [];

        console.log('[DEBUG] 모달 열림');

        await this.service.render();
    }

    public closeGenerateModal() {
        this.modalOpen = false;
        this.service.render();
    }

    public async generateQA() {
        if (this.generating) return;

        if (!this.group) {
            alert("그룹 정보가 없습니다.");
            return;
        }

        if (this.group?.status_closed === "Y") {
            alert("이미 마감된 그룹입니다.");
            return;
        }

        const total = this.genCount || 0;
        if (total <= 0) {
            alert("1개 이상 생성 개수를 입력하세요.");
            return;
        }

        const selectedMainTypes = this.genTypes.filter(t =>
            this.mainTypes.some(m => m.value === t)
        );

        if (selectedMainTypes.length === 0) {
            alert("최소 1개 이상의 주 라벨을 선택해야 합니다.");
            return;
        }

        const selectedAuxTypes = this.genTypes.filter(t =>
            this.auxiliaryTypes.some(a => a.value === t)
        );

        if (selectedAuxTypes.length > 2) {
            alert("보조 라벨은 최대 2개까지만 선택 가능합니다.");
            return;
        }

        const totalCount = selectedMainTypes.length * total;

        const auxLabels = selectedAuxTypes.length > 0
            ? ` (${selectedAuxTypes.map(t => this.getTypeLabel(t)).join(', ')} 적용)`
            : '';

        const confirmMsg = `${selectedMainTypes.length}개 주 라벨 × ${total}개 = 총 ${totalCount}개의 QA를 생성합니다.${auxLabels}\n계속하시겠습니까?`;
        if (!confirm(confirmMsg)) {
            return;
        }

        console.log('[DEBUG] 주 라벨:', selectedMainTypes);
        console.log('[DEBUG] 보조 라벨:', selectedAuxTypes);
        console.log('[DEBUG] genPrompt:', this.genPrompt);
        console.log('[DEBUG] 각 주 라벨당 개수:', total);
        console.log('[DEBUG] 총 생성 개수:', totalCount);

        this.generating = true;
        this.progressTotal = totalCount;
        this.progressCurrent = 0;
        await this.service.render();

        const params = new URLSearchParams();
        params.append("group_id", this.group.id);
        params.append("vectordb_id", this.group.vectordb_id);
        params.append("count", String(total));
        params.append("type", selectedMainTypes[0] || "summary");
        params.append("main_types", JSON.stringify(selectedMainTypes));
        params.append("aux_types", JSON.stringify(selectedAuxTypes));
        params.append("prompt", this.genPrompt || "");
        params.append("model", this.selectedModel);
        params.append("system_prompt", this.systemPrompt || "");

        const url = wiz.url('stream') + '?' + params.toString();

        console.log('[generateQA] selectedModel:', this.selectedModel);

        try {
            const res = await fetch(url, {
                method: "GET",
            });

            console.log('[DEBUG] Response 상태:', res.status, res.statusText);

            if (!res.ok) {
                throw new Error(`HTTP ${res.status}: ${res.statusText}`);
            }

            const reader = res.body.getReader();
            const decoder = new TextDecoder("utf-8");

            let isStreaming = true;
            let finished = false;
            let hasError = false;
            let errorMessage = "";

            while (isStreaming) {
                const { value, done } = await reader.read();

                if (done) {
                    console.log('[DEBUG] 스트림 종료 (done)');
                    isStreaming = false;
                    break;
                }

                const chunk = decoder.decode(value, { stream: true });
                console.log('[DEBUG] 받은 청크:', chunk);

                const events = chunk.split('\n');

                for (const event of events) {
                    if (!event.trim() || !event.startsWith("data:")) continue;

                    try {
                        const jsonData = JSON.parse(event.replace(/^data:\s*/, "").trim());
                        console.log('[DEBUG] 파싱된 데이터:', jsonData);

                        if (jsonData.type === "finish") {
                            finished = true;
                            isStreaming = false;
                            break;
                        } else if (jsonData.type === "log") {
                            this.progressCurrent = jsonData.data;
                            this.service.render();
                        } else if (jsonData.type === "error") {
                            console.error('[ERROR] 서버 에러:', jsonData.message);
                            hasError = true;
                            errorMessage = jsonData.message || "알 수 없는 오류";
                            isStreaming = false;
                            break;
                        }
                    } catch (error) {
                        console.error("JSON parse error:", error, "raw:", event);
                    }
                }
            }

            this.generating = false;
            this.modalOpen = false;
            await this.service.render();

            if (hasError) {
                alert(`오류 발생: ${errorMessage}`);
            } else if (finished) {
                alert(`${this.progressCurrent}개 생성되었습니다.`);
            } else {
                alert("QA 생성 중 오류 발생 (스트림 비정상 종료)");
            }

        } catch (error) {
            console.error('[ERROR] generateQA 실행 중 오류:', error);
            this.generating = false;
            this.modalOpen = false;
            await this.service.render();
            alert(`오류 발생: ${error.message || error}`);
        }

        await this.loadAll();
    }

    public goBackToList() {
        const currentUrl = this.router?.url || '';
        if (currentUrl.startsWith('/ui/qainstruct')) {
            this.router.navigateByUrl('ui/qainstruct');
            return;
        }
        this.router.navigateByUrl('ui/qadataset');
    }

    public async reload() {
        await this.loadAll();
    }

    public get progressPercent(): number {
        if (!this.progressTotal || this.progressTotal <= 0) return 0;
        const ratio = (this.progressCurrent / this.progressTotal) * 100;
        return Math.max(0, Math.min(100, Math.round(ratio)));
    }

    isDragging = false;
    modalX = 0;
    modalY = 0;
    dragStartX = 0;
    dragStartY = 0;

    startDrag(event: MouseEvent, modalEl: HTMLElement) {
        if (!modalEl) return;
        event.preventDefault();

        this.isDragging = true;

        const rect = modalEl.getBoundingClientRect();
        this.dragStartX = event.clientX - rect.left;
        this.dragStartY = event.clientY - rect.top;

        const onMove = (e: MouseEvent) => {
            if (!this.isDragging) return;

            modalEl.style.left = e.clientX - this.dragStartX + 'px';
            modalEl.style.top = e.clientY - this.dragStartY + 'px';
            modalEl.style.transform = 'none';
            modalEl.style.position = 'fixed';
        };

        const onUp = () => {
            this.isDragging = false;
            document.removeEventListener('mousemove', onMove);
            document.removeEventListener('mouseup', onUp);
        };

        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onUp);
    }

    onDrag = (event: MouseEvent) => {
        if (!this.isDragging) return;

        this.modalX = event.clientX - this.dragStartX;
        this.modalY = event.clientY - this.dragStartY;
    };

    stopDrag = () => {
        this.isDragging = false;
        document.removeEventListener('mousemove', this.onDrag);
        document.removeEventListener('mouseup', this.stopDrag);
    };

    public reviewerModalOpen: boolean = false;
    public currentReviewers: any[] = [];
    public allUsers: any[] = [];
    public filteredUsers: any[] = [];
    public randomAssignedUsers: any[] = [];
    public userSearch: string = "";
    public dropdownOpen: boolean = false;
    public maxReviewerCount: number = 1;

    public async openReviewerModal() {
        this.reviewerModalOpen = true;

        const assignedRes = await wiz.call("get_assigned_users", {
            group_id: this.id
        });

        const users = assignedRes?.data?.users || [];
        this.currentReviewers = users.map(u => ({
            id: u.id,
            name: u.name,
            email: u.email
        }));

        await this.loadUsers();

        this.userSearch = "";
        this.dropdownOpen = false;
        this.randomAssignedUsers = [];

        await this.service.render();
    }

    public async closeReviewerModal() {
        this.reviewerModalOpen = false;
        this.currentReviewers = [];
        this.userSearch = "";
        this.dropdownOpen = false;
        this.randomAssignedUsers = [];
        await this.service.render();
    }

    public async loadUsers() {
        const res = await wiz.call("list_users");
        this.allUsers = res.data?.users || [];
        this.filteredUsers = [...this.allUsers];
        await this.service.render();
    }

    public async openUserDropdown() {
        this.dropdownOpen = true;
        this.filteredUsers = [...this.allUsers];
        await this.service.render();
    }

    public async filterUsers() {
        const q = (this.userSearch || "").toLowerCase();

        if (!q) {
            this.filteredUsers = [...this.allUsers];
            return;
        }

        this.filteredUsers = this.allUsers.filter(u =>
            u.name.toLowerCase().includes(q) ||
            u.email.toLowerCase().includes(q)
        );
        await this.service.render();
    }

    public async addReviewer(user: any) {
        if (this.currentReviewers.find(u => u.id === user.id)) return;

        this.currentReviewers.push({
            id: user.id,
            name: user.name,
            email: user.email
        });

        this.userSearch = "";
        this.dropdownOpen = false;
        await this.service.render();
    }

    public async removeReviewer(user: any) {
        this.currentReviewers = this.currentReviewers.filter(u => u.id !== user.id);
        this.randomAssignedUsers = [];
        await this.service.render();
    }

    public async assignRandomUsers() {
        const res = await wiz.call("assign_random_reviewers", {
            limit: this.maxReviewerCount
        });

        const reviewers = res?.data?.reviewers || res?.reviewers || [];

        if (!reviewers || reviewers.length === 0) {
            alert("배정 가능한 검수자가 없습니다.");
            return;
        }

        const currentCount = this.currentReviewers.length;
        const needed = this.maxReviewerCount - currentCount;

        if (needed <= 0) {
            alert(`이미 ${this.maxReviewerCount}명이 배정되어 있습니다.`);
            return;
        }

        let added = 0;
        for (const u of reviewers) {
            if (added >= needed) break;

            if (this.currentReviewers.find(r => r.id === u.id)) {
                continue;
            }

            this.currentReviewers.push({
                id: u.id,
                name: u.name,
                email: u.email || ""
            });
            added++;
        }

        this.randomAssignedUsers = reviewers.slice(0, needed);

        console.log(`✅ ${added}명 추가됨 (총 ${this.currentReviewers.length}명)`);

        await this.service.render();
    }

    public async saveReviewers() {
        if (!this.id) {
            alert("그룹 ID가 없습니다.");
            return;
        }

        const reviewer_ids = this.currentReviewers.map(u => u.id);

        const res = await wiz.call("update_group_reviewers", {
            group_id: this.id,
            assigned_user_ids: JSON.stringify(reviewer_ids)
        });

        if (res?.code === 200) {
            alert("검수자가 업데이트되었습니다!");
            this.closeReviewerModal();

            await this.loadGroup();
        } else {
            alert(res?.error || "검수자 업데이트 실패");
        }

        await this.service.render();
    }

    public onUserInputBlur() {
        setTimeout(() => {
            this.dropdownOpen = false;
            this.service.render();
        }, 200);
    }

    public onUserMouseDown(event: MouseEvent) {
        event.preventDefault();
    }

    toggleType(type: string): void {
        const index = this.genTypes.indexOf(type);
        if (index > -1) {
            this.genTypes.splice(index, 1);
        } else {
            if (this.isAuxiliaryType(type)) {
                const auxiliaryCount = this.genTypes.filter(t => this.isAuxiliaryType(t)).length;
                if (auxiliaryCount >= 2) {
                    alert('보조 라벨은 최대 2개까지만 선택할 수 있습니다.');
                    return;
                }
            }
            this.genTypes.push(type);
            
            // ===== 타입 선택 시 프롬프트가 없으면 기본값 설정 =====
            if (!this.typePrompts[type]) {
                this.typePrompts[type] = this.DEFAULT_PROMPTS.typePrompts[type] || '';
            }
        }
        this.service.render();
    }

    public isTypeSelected(typeValue: string): boolean {
        return this.genTypes.includes(typeValue);
    }

    public getTypeLabel(typeValue: string): string {
        const found = this.allTypes.find(t => t.value === typeValue);
        const label = found ? found.label : typeValue;
        return label;
    }

    public updatePromptForTypes() {
        const hints = this.genTypes.map(t => this.TYPE_HINT[t]).filter(Boolean);
        this.selectedTypesHints = hints;
        this.service.render();
    }

    public async regenerateQA(q: any) {
        if (!q || !q.id) return;

        const confirmMsg = `이 Q&A를 재생성하시겠습니까?\n\n기존 데이터는 삭제되고 새로운 Q&A가 생성됩니다.`;
        if (!confirm(confirmMsg)) return;

        try {
            const questionType = q.question_type || 'summary';
            const sourceFile = q.source_file;
            const sourcePage = q.source_page;

            console.log('[regenerateQA] 요청 파라미터:', {
                qa_id: q.id,
                group_id: this.id,
                vectordb_id: this.group?.vectordb_id,
                question_type: questionType,
                source_file: sourceFile,
                source_page: sourcePage,
                model: this.selectedModel || 'gpt-5.2'
            });

            const res = await wiz.call("regenerate_single_qa", {
                qa_id: q.id,
                group_id: this.id,
                vectordb_id: this.group?.vectordb_id,
                question_type: questionType,
                source_file: sourceFile,
                source_page: sourcePage,
                model: this.selectedModel || 'gpt-5.2'
            });

            console.log('[regenerateQA] API 응답:', res);

            if (res && res.message) {
                alert("Q&A가 재생성되었습니다.");
                await this.loadQuestions();
                await this.service.render();
                return;
            }

            if (res && res.code === 200) {
                alert("Q&A가 재생성되었습니다.");
                await this.loadQuestions();
                await this.service.render();
                return;
            }

            if (res && res.data && res.data.message) {
                alert("Q&A가 재생성되었습니다.");
                await this.loadQuestions();
                await this.service.render();
                return;
            }

            console.error('[regenerateQA] 예상치 못한 응답 형태:', res);
            alert(res?.error || res?.data?.error || "재생성 실패");

        } catch (e) {
            console.error("[regenerateQA] 오류:", e);
            alert("재생성 중 오류가 발생했습니다.");
        }
    }

    public formatModelName(model: string): string {
        if (!model) return '';

        if (model.toLowerCase().includes('gpt')) {
            const match = model.match(/gpt-?(\d+\.?\d*)/i);
            if (match) {
                return `GPT-${match[1]}`;
            }
        }

        if (model.toLowerCase().includes('gemini')) {
            const match = model.match(/gemini-?(\d+)/i);
            if (match) {
                return `Gemini-${match[1]}`;
            }
        }

        if (model.toLowerCase().includes('claude')) {
            if (model.includes('sonnet')) {
                const match = model.match(/(\d+)/);
                return match ? `Claude Sonnet ${match[1]}` : 'Claude Sonnet';
            }
            if (model.includes('opus')) {
                const match = model.match(/(\d+)/);
                return match ? `Claude Opus ${match[1]}` : 'Claude Opus';
            }
            if (model.includes('haiku')) {
                const match = model.match(/(\d+)/);
                return match ? `Claude Haiku ${match[1]}` : 'Claude Haiku';
            }
        }

        return model;
    }

    public formatAnswer(answer: string | null | undefined): string {
        if (!answer) return '';

        const cleaned = answer.replace(/(\n|^)\s*referenced_sentences\s*[:=][\s\S]*$/i, '').trim();
        return cleaned;
    }

    public parseAuxTypes(auxTypes: any): string[] {
        if (!auxTypes) return [];

        if (Array.isArray(auxTypes)) return auxTypes;

        if (typeof auxTypes === 'string') {
            try {
                const parsed = JSON.parse(auxTypes);
                return Array.isArray(parsed) ? parsed : [];
            } catch {
                return auxTypes.split(',').map(s => s.trim()).filter(Boolean);
            }
        }

        return [];
    }

    public async setQuestionStatusFromModal(status: 'pending' | 'approved' | 'rejected') {
        if (!this.currentQuestion || !this.currentQuestion.id) return;

        const prevStatus = this.currentQuestion.status;
        const prevComment = this.currentQuestion.comment;

        this.currentQuestion.status = status;
        await this.service.render();

        try {
            const res = await wiz.call("update_question_status", {
                id: this.currentQuestion.id,
                status,
                comment: this.currentQuestion.comment || ""
            });

            if (!res || res.code !== 200) {
                this.currentQuestion.status = prevStatus;
                this.currentQuestion.comment = prevComment;
                alert(res?.error || "상태 변경 실패");
                await this.service.render();
                return;
            }

            const questionInList = this.questions.find(item => item.id === this.currentQuestion.id);
            if (questionInList) {
                questionInList.status = status;
                questionInList.comment = this.currentQuestion.comment;
            }

            await this.loadGroupInfo();
            await this.loadQuestions();

            this.closePdfModal();

        } catch (e) {
            this.currentQuestion.status = prevStatus;
            this.currentQuestion.comment = prevComment;
            alert("상태 변경 중 오류");
        }

        await this.service.render();
    }

    public closePdfModal() {
        this.showPdf = false;
        this.currentQuestion = null;
        this.topKDocs = [];
        this.pdfSrc = null;
        this.isContextMode = false;
        this.contextText = "";
        this.service.render();
    }

    public getHighlightedContext(): string {
        if (!this.contextText) {
            return this.contextText || '';
        }

        console.log('원본 contextText:', this.contextText);

        let htmlContent = this.convertMarkdownTableToHTML(this.contextText);
        console.log('변환된 HTML:', htmlContent);

        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlContent;

        const tables = tempDiv.querySelectorAll('table');
        console.log('발견된 표 개수:', tables.length);

        tables.forEach(table => {
            table.className = 'w-full border-collapse my-4 border border-gray-300';
            
            table.querySelectorAll('th').forEach(th => {
                th.className = 'border border-gray-300 px-3 py-2 bg-gray-100 font-semibold text-left';
            });
            
            table.querySelectorAll('td').forEach(td => {
                td.className = 'border border-gray-300 px-3 py-2';
            });
        });

        if (this.currentQuestion?.referenced_sentences) {
            try {
                const sentences = typeof this.currentQuestion.referenced_sentences === 'string'
                    ? JSON.parse(this.currentQuestion.referenced_sentences)
                    : this.currentQuestion.referenced_sentences;

                let highlighted = tempDiv.innerHTML;
                let matchCount = 0;

                sentences.forEach((sentence: string) => {
                    const trimmed = sentence.trim();
                    if (highlighted.includes(trimmed)) {
                        highlighted = highlighted.split(trimmed).join(
                            `<mark class="bg-yellow-200 px-1 rounded">${trimmed}</mark>`
                        );
                        matchCount++;
                        console.log(`✅ 하이라이트됨: "${trimmed.substring(0, 50)}..."`);
                    }
                });

                console.log(`총 ${matchCount}개 문장 하이라이트됨`);
                return highlighted;

            } catch (e) {
                console.error('referenced_sentences 파싱 실패:', e);
            }
        }

        return tempDiv.innerHTML;
    }

    private convertMarkdownTableToHTML(text: string): string {
        const lines = text.split('\n');
        let html = '';
        let inTable = false;
        let tableLines: string[] = [];

        for (let i = 0; i < lines.length; i++) {
            const line = lines[i].trim();

            if (line.includes('|')) {
                if (!inTable) {
                    inTable = true;
                    tableLines = [];
                }
                tableLines.push(line);
            } else {
                if (inTable && tableLines.length > 0) {
                    html += this.buildTableHTML(tableLines);
                    tableLines = [];
                    inTable = false;
                }
                if (line) {
                    html += `<p>${line}</p>\n`;
                }
            }
        }

        if (inTable && tableLines.length > 0) {
            html += this.buildTableHTML(tableLines);
        }

        return html;
    }

    private buildTableHTML(tableLines: string[]): string {
        if (tableLines.length === 0) return '';

        let html = '<table>\n';
        
        const headerCells = tableLines[0].split('|')
            .map(cell => cell.trim())
            .filter(cell => cell);
        
        html += '  <thead>\n    <tr>\n';
        headerCells.forEach(cell => {
            html += `      <th>${cell}</th>\n`;
        });
        html += '    </tr>\n  </thead>\n';

        if (tableLines.length > 1) {
            html += '  <tbody>\n';
            for (let i = 1; i < tableLines.length; i++) {
                const dataCells = tableLines[i].split('|')
                    .map(cell => cell.trim())
                    .filter(cell => cell);
                
                if (dataCells.length > 0) {
                    html += '    <tr>\n';
                    dataCells.forEach(cell => {
                        html += `      <td>${cell}</td>\n`;
                    });
                    html += '    </tr>\n';
                }
            }
            html += '  </tbody>\n';
        }

        html += '</table>\n';
        return html;
    }

    public async downloadExcel() {
        if (!this.group || !this.id) {
            alert("그룹 정보가 없습니다.");
            return;
        }

        try {
            const url = wiz.url('download_qa_excel') + `?group_id=${this.id}`;

            window.open(url, '_blank');

            const res = await fetch(url);

            if (!res.ok) {
                throw new Error('다운로드 실패');
            }

            const blob = await res.blob();
            const downloadUrl = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = downloadUrl;
            a.download = `QA_검수_${this.group.group_name}.xlsx`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(downloadUrl);

            console.log('[엑셀 다운로드] 성공');

        } catch (e) {
            console.error('[엑셀 다운로드] 오류:', e);
            alert('엑셀 다운로드 중 오류가 발생했습니다.');
        }
    }

    // 검수자별 엑셀 다운로드 (선택된 reviewer_id로 API 호출)
    public async downloadReviewerExcel(reviewer_id: string) {
        if (!this.group || !this.id || !reviewer_id) {
            alert("그룹 정보 또는 검수자 정보가 없습니다.");
            return;
        }

        try {
            const url = wiz.url('download_qa_excel_by_reviewer') + `?group_id=${this.id}&reviewer_id=${reviewer_id}`;

            // 파일 다운로드
            const res = await fetch(url);
            if (!res.ok) {
                throw new Error('다운로드 실패');
            }
            const blob = await res.blob();
            const downloadUrl = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = downloadUrl;
            a.download = `QA_검수_${this.group.group_name}_reviewer_${reviewer_id}.xlsx`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(downloadUrl);

            // 다운로드 후 드롭다운 닫기 및 선택 초기화
            this.showReviewerDropdown = false;
            this.selectedReviewer = "";

            console.log('[엑셀 다운로드] 검수자별 파일 다운로드 성공');
        } catch (e) {
            console.error('[엑셀 다운로드] 오류:', e);
            alert('엑셀 다운로드 중 오류가 발생했습니다.');
        }
    }

    public triggerFileUpload() {
        const fileInput = document.getElementById('fileUploadInput') as HTMLInputElement;

        if (fileInput) {
            fileInput.click();
        } else {
            alert('파일 입력 요소를 찾을 수 없습니다.');
        }
    }

    public async uploadExcel(event: any) {
        console.log('[uploadExcel] 호출됨');
        console.log('[uploadExcel] event:', event);

        const file = event.target.files?.[0];
        console.log('[uploadExcel] file:', file);

        if (!file) {
            console.log('[uploadExcel] 파일 선택 취소됨');
            return;
        }

        const fileName = file.name.toLowerCase();
        console.log('[uploadExcel] fileName:', fileName);

        if (!fileName.endsWith('.xlsx') && !fileName.endsWith('.xls')) {
            alert('엑셀 파일(.xlsx, .xls)만 업로드 가능합니다.');
            event.target.value = '';
            return;
        }

        const confirmMsg = `"${file.name}" 파일을 업로드하여 검수 결과를 반영하시겠습니까?\n\n기존 검수 내용이 변경될 수 있습니다.`;
        if (!confirm(confirmMsg)) {
            event.target.value = '';
            return;
        }

        this.uploadingExcel = true;
        this.uploadProgress = "엑셀 파일 업로드 중...";
        await this.service.render();

        try {
            const formData = new FormData();
            formData.append('file', file, file.name);
            formData.append('group_id', this.id);

            console.log('[uploadExcel] FormData 생성 완료');
            console.log('[uploadExcel] group_id:', this.id);
            console.log('[uploadExcel] file.name:', file.name);
            console.log('[uploadExcel] file.size:', file.size);
            console.log('[uploadExcel] file.type:', file.type);

            for (let pair of formData.entries()) {
                console.log('[uploadExcel] FormData:', pair[0], pair[1]);
            }

            const apiUrl = wiz.url('upload_qa_excel');
            console.log('[uploadExcel] API URL:', apiUrl);

            console.log('[uploadExcel] fetch 시작...');

            const res = await fetch(apiUrl, {
                method: 'POST',
                body: formData
            });

            console.log('[uploadExcel] fetch 완료');
            console.log('[uploadExcel] response.status:', res.status);
            console.log('[uploadExcel] response.ok:', res.ok);

            const result = await res.json();
            console.log('[uploadExcel] 결과:', result);

            if (res.ok && result.code === 200) {
                const data = result.data || result;

                const successCount = data.success_count || 0;
                const failCount = data.fail_count || 0;
                const totalCount = data.total_count || 0;

                let message = `엑셀 업로드 완료!\n\n`;
                message += `총 ${totalCount}개 중\n`;
                message += `✅ 성공: ${successCount}개\n`;
                if (failCount > 0) {
                    message += `❌ 실패: ${failCount}개\n`;
                }

                alert(message);
                await this.loadAll();

            } else {
                throw new Error(result.error || result.data?.error || '업로드 실패');
            }

        } catch (e) {
            console.error('[uploadExcel] 오류:', e);
            alert(`엑셀 업로드 중 오류가 발생했습니다.\n\n${(e as any).message || e}`);
        } finally {
            this.uploadingExcel = false;
            this.uploadProgress = "";
            event.target.value = '';
            await this.service.render();
        }
    }

    @HostListener('window:scroll', [])
    onWindowScroll() {
        if (this.scrollContainer) {
            return;
        }
        this.updateScrollButton(this.getWindowScrollOffset());
    }

    private getWindowScrollOffset(): number {
        return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    }

    private updateScrollButton(offset: number) {
        const shouldShow = offset > 300;
        if (this.showScrollTopButton !== shouldShow) {
            this.showScrollTopButton = shouldShow;
            this.service.render();
        }
    }

    scrollToTop() {
        if (this.scrollContainer) {
            this.scrollContainer.scrollTo({ top: 0, behavior: 'smooth' });
            return;
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    setViewMode(mode: 'card' | 'list') {
        this.viewMode = mode;
        if (mode === 'card') {
            this.expandedQuestions.clear();
        }
    }

    toggleQuestion(index: number) {
        if (this.expandedQuestions.has(index)) {
            this.expandedQuestions.delete(index);
        } else {
            this.expandedQuestions.add(index);
        }
    }

    isExpanded(index: number): boolean {
        return this.expandedQuestions.has(index);
    }
}

export default PortalQadatasetVerifyComponent;